// extracted by mini-css-extract-plugin
export default {"card":"QuickActions_card__R1dX-","title":"QuickActions_title__GUBSV","primary":"QuickActions_primary__tj3vA","secondary":"QuickActions_secondary__NZNFr"};